import styled from 'styled-components'
import { grid, layout, margin, padding, position } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PADDING_X } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.attrs({
  py: [6, 6, 15],
  px: PADDING_X,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.almond')};

  ${padding}
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${BLUEPRINT_WIDTH}px;
`

export const DotsContainer = styled.div.attrs({
  top: [-40],
  right: [-40],
  display: ['none', 'none', 'none', 'flex'],
})`
  position: absolute;
  z-index: 0;

  ${position}
  ${layout}
`

export const CardContainer = styled.div
  .attrs({
    gridTemplateColumns: [
      '1fr',
      '1fr',
      'repeat(2, 1fr)',
      'repeat(2, 1fr)',
      'repeat(2, 1fr)',
      'repeat(3, 1fr)',
    ],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;
  width: 100%;
  grid-gap: 30px;
  position: relative;

  ${grid}
  ${margin}
`

export const Card = styled.div.attrs({
  px: [9],
  py: [6, 6, 6, 9],
})`
  background-color: ${themeGet('colors.bg.default')};
  border-radius: 20px;
  display: flex;
  align-items: center;
  border: 1px solid ${themeGet('colors.pinkAmaranthDull')};
  z-index: 12;

  ${padding}
`

export const StyledImage = styled.img`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  object-fit: contain;
`
